import '@/setup/nprogress'
import '@/setup/vue-meta'
import '@/setup/snotify'
import '@/setup/axios'
import '@/setup/vuecomponents'
import '@/setup/vuex'

import Vue from 'vue'
import App from '@/App'
import i18n from '@/setup/i18n'
import router from '@/router'
import store from '@/store'

import '@/setup/vue-auth'

Vue.config.productionTip = false

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
